/**
 * Vuex getters for the "securityAuth" (twoFactorAuth) module.
 *
 * Thin state accessors exposing the 2FA enrollment/status state as-is.
 */
export default {
  isTwoFaEnabled: (state) => state.isTwoFaEnabled,
  qrDataUrl: (state) => state.qrDataUrl,
  secretKey: (state) => state.secretKey,
  isLoading: (state) => state.isLoading,
  message: (state) => state.message,
};
